import React from 'react'

export default function Footer() {
  return (
    <div>
      <footer className="footer">
        <div className="container">
          <div className="row">

            {/* Quick Links Section */}
            <div className="col-md-6 col-lg-3 col-xl-3">
              <div className="block mb-4 mb-lg-0">
                <h5 className="footer-nav-title text-light">Quick Links</h5>
                <ul className="footer-nav-list">
                  <li><a href="/">Home</a></li>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/projects">Projects</a></li>
                  <li><a href="/services">Services</a></li>
                  <li><a href="/contact">Contact</a></li>
                </ul>
              </div>
            </div>

            {/* About Section */}
            <div className="col-md-6 col-lg-3 col-xl-3">
              <div className="block mb-4 mb-lg-0">
                <h5 className="footer-nav-title text-light">About</h5>
                <p className="text-light small">
                  We are dedicated to delivering high-quality solutions and services that help our clients succeed. 
                  From innovative projects to excellent customer service, we’re here for you.
                </p>
              </div>
            </div>

            {/* Services Section */}
            <div className="col-md-6 col-lg-3 col-xl-3">
              <div className="block mb-4 mb-lg-0">
                <h5 className="footer-nav-title text-light">Services</h5>
                <ul className="footer-nav-list">
                  <li><a href="/services">Design & Engineering</a></li>
                  <li><a href="/services">Ductwork Installation</a></li>
                  <li><a href="/services">Pipework Installation</a></li>
                  <li><a href="/services">Project Management & Construction</a></li>
                  <li><a href="/services">HVAC Maintenance & Servicing</a></li>
                </ul>
              </div>
            </div>

            {/* Contact Info Section */}
            <div className="col-md-6 col-lg-3 col-xl-3">
              <div className="block">
                <h5 className="footer-nav-title text-light">Contact</h5>
                <ul className="footer-nav-list">
                  <li><a href="mailto:tracs@tracs.com.au">tracs@tracs.com.au</a></li>
                  <li><a href="tel:+610893534544"> +61 08 9353 4544</a></li>
                  
                </ul>
              </div>
            </div>

          </div>
        </div>
      </footer>

      {/* Copyright */}
      <div className="copyright">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="block copyright-content mb-2 mb-md-0">
                <p className="m-0 text-light">
                  Copyrights &copy; {new Date().getFullYear()} All Rights Reserved by{' '}
                  <a className="company-name activeColor text-uppercase" href="/">
                    Tracs
                  </a>
                </p>
              </div>
            </div>

            {/* Social Media */}
            {/* <div className="col-md-6">
              <div className="block social-media d-flex justify-content-center justify-content-md-end">
                <a className="ct-twitter d-flex justify-content-center align-items-center" href="#">
                  <i className="fab fa-twitter" aria-hidden="true"></i>
                </a>
                <a className="ct-facebookr d-flex justify-content-center align-items-center" href="#">
                  <i className="fab fa-facebook-f" aria-hidden="true"></i>
                </a>
                <a className="ct-instagramr d-flex justify-content-center align-items-center" href="#">
                  <i className="fab fa-linkedin-in" aria-hidden="true"></i>
                </a>
                <a className="ct-skype d-flex justify-content-center align-items-center" href="#">
                  <i className="fab fa-skype" aria-hidden="true"></i>
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
